import api from './api';

/**
 * Werbe-Einwilligung für Google Ads Kundenabgleich (SEO-Auftrag, Marcel 2026-10-06): nur Nutzer mit Konto.
 * Text und Version kommen vom Backend (eine Quelle für Web + App).
 */
export interface AdConsentState {
  personalizedAds: boolean | null;
  decidedAt: number | null;
  version: string | null;
  currentVersion: string;
  needsDecision: boolean;
  company?: string;
  title?: { de: string; en: string };
  text?: { de: string; en: string };
}
export interface AdConsentStats { version: string; total: number; granted: number; denied: number; open: number; lastExport: { at: number; count: number; version: string } | null }
export interface AdConsentExport { id: string; at: number; by: string | null; count: number; version: string }

/** PURE: Text in der gewünschten Sprache, DE-Fallback, Absätze an \n\n getrennt */
export function adConsentParagraphs(state: Pick<AdConsentState, 'text'> | null | undefined, lang: string): string[] {
  const t = state?.text;
  const raw = (lang.startsWith('en') ? t?.en : t?.de) || t?.de || '';
  return raw.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
}

class AdConsentService {
  async getMine(): Promise<AdConsentState> {
    const res = await api.get('/api/user/ad-consent');
    return res.data;
  }
  async setMine(personalizedAds: boolean): Promise<AdConsentState> {
    const res = await api.post('/api/user/ad-consent', { personalizedAds, source: 'web' });
    return res.data;
  }
  async stats(): Promise<AdConsentStats> {
    const res = await api.get('/api/admin/ad-consent/stats');
    return res.data;
  }
  async exports(): Promise<AdConsentExport[]> {
    const res = await api.get('/api/admin/ad-consent/exports');
    return Array.isArray(res.data) ? res.data : [];
  }
  /** CSV als Text (Download macht die Seite über einen Blob) */
  async exportCsv(): Promise<string> {
    const res = await api.get('/api/admin/ad-consent/export.csv', { responseType: 'text' });
    return typeof res.data === 'string' ? res.data : String(res.data ?? '');
  }
}

const adConsentService = new AdConsentService();
export default adConsentService;
